import React from 'react'
import ReactDom from 'react-dom'

class Error extends React.Component {

  constructor(props) {
    super(props)

    this.handleClose = this.handleClose.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.message !== this.props.message
  }

  handleClose(event) {
    if (this.props.onErrorClick) {
      event.preventDefault()
      this.props.onErrorClick({
        message: null
      })
    }
  }

  render() {
    const {
      message
    } = this.props

    return (
      <div id="error-container" onClick={this.handleClose}>
      	<div className="error" onClick={(event) => event.stopPropagation()}>
      		<a className="close-error" href="#" onClick={this.handleClose}>
            Go<span>Back</span>
          </a>
      		<div className="main-error-container">
      			<p>{message}</p>
      		</div>
      	</div>
      </div>
    )
  }
}

export default Error
